var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17277",
    "data-name": "Groupe 17277",
    transform: "translate(-1692 -528)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5326",
    "data-name": "Rectangle 5326",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(1692 528)",
    fill: "#fd0d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-youtube",
    "data-name": "Icon ionic-logo-youtube",
    d: "M25.972,8.83a3.97,3.97,0,0,0-3.779-4.147c-2.829-.133-5.714-.184-8.661-.184h-.919c-2.941,0-5.832.051-8.661.184A3.978,3.978,0,0,0,.179,8.841C.051,10.659-.005,12.477,0,14.295s.051,3.636.174,5.459a3.983,3.983,0,0,0,3.774,4.162c2.972.138,6.021.2,9.121.194q4.657.015,9.121-.194a3.984,3.984,0,0,0,3.779-4.162c.123-1.823.179-3.641.174-5.464Q26.156,11.563,25.972,8.83ZM10.571,19.3V9.27l7.4,5.015Z",
    transform: "translate(1699.555 534.18)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.57d56c5d2279cc404644eaf13359966f.svg";
export { ForwardRef as ReactComponent };